import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { FrattaleService } from 'src/app/services/frattale.service';

@Component({
  selector: 'app-daxtrend',
  standalone: true,
  templateUrl: './daxtrend.component.html',
  styleUrls: ['./daxtrend.component.scss'],
  imports: [CommonModule, MdbTabsModule, ReactiveFormsModule,
    MdbFormsModule
  ]
})
export class DaxtrendComponent implements OnInit {

  righeBuy:any[] = [];
  righeSell:any[] = [];
  colora: Array<any> =[]
  colora2: Array<any> =[]
  colonne: any[] = [0,1,2,3,4,5]
  mesi: any[] = []

  percBuySell = new FormGroup({
    percBuy: new FormControl(''),
    percSell: new FormControl('')
  })

  constructor(private service: FrattaleService) {
    for(let i=0;i<23;i++){
      let a: Array<number> = []
      let b: Array<number> = []
      let c: Array<number> = []
      for(let j=0; j<5;j++){
        a.push(0)
        b.push(0)
        c.push(j)
      }
      this.colora.push(a)
      this.colora2.push(b)      
      this.righeBuy.push(c)
      this.righeSell.push(c)
    }
   }

  ngOnInit(): void {
    this.service.daxTrendRead().subscribe((data:any)=>{
      console.log(data)
      this.mesi = data.data.month
      let gg = data.data.day
      let buy = gg.filter((d:any)=>d.verso=='buy')
      console.log(buy, this.righeBuy)
      buy.forEach((element: any) => {
        this.colora2[element.mese-1][element.settimana] = element.flag
      });
      let sell = gg.filter((d:any)=>d.verso=='sell')
      sell.forEach((element: any) => {
        this.colora[element.mese-1][element.settimana] = element.flag
      });
      this.mesi.map((m:any,i:number)=>{
        let pp = new Date().getFullYear() + '-' + (parseInt(m.mese) +1) + '-' + '01'
        m.mese = new Date(pp).toLocaleString('it-IT',{month:'long'})
      })
      this.percBuySell.setValue({
        percBuy: data.data.perc[0].buy,
        percSell: data.data.perc[0].sell
      })
    })
    console.log(this.righeBuy)
  }

  cambiaMese(id: number, verso: string, b: number){
    console.log(id,verso, b)
    this.service.daxTrendUpdateMonth(id, verso, b).subscribe((data:any)=>{
      console.log(data)
      if(data.res=='ok'){
        this.mesi[id-1][verso] = b
      }
    })
  }

  cambiaSell(id: number,b: number, c: number){
    console.log(id,b)
    this.service.daxTrendSave('sell',id,b,c).subscribe((data:any)=>{
      console.log(data)
      this.colora[id][b] = this.colora[id][b]==0 ? 1 : 0
    })
  }

  cambiaBuy(id: number,b: any, c: number){
    console.log(id,b)
    this.service.daxTrendSave('buy',id,b,c).subscribe((data:any)=>{
      console.log(data)
      this.colora2[id][b] = this.colora2[id][b]==0 ? 1 : 0
    })
  }

  salvaPerc(){
    console.log(this.percBuySell.value)
    this.service.daxTrendUpdatePerc(this.percBuySell.value).subscribe((data:any)=>{
      console.log(data)
    })
  }

}
